import { blue } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { Marker, PointLike } from 'react-map-gl';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useMeasureToolMarkers } from '../features/measurePopup/hooks/useMeasureToolMarkers';
import LocationSVG from '../icons/LocationSVG';
import { selectMapMarkers, setCurrMapMarkerPopup } from '../mapSlice';

const markerSize = 50;
const markerOffset: PointLike = [0, -markerSize / 2];

const MarkerLayer: React.FC = () => {
  /**
   * Create markers for the Measure Tool
   */
  const measureMarkers = useMeasureToolMarkers(markerOffset, markerSize);

  /**
   * Create general map markers
   */
  const dispatch = useAppDispatch();
  const mapMarkers = useAppSelector(selectMapMarkers);
  const markersRender = useMemo(() => {
    const markers: JSX.Element[] = [];

    if (mapMarkers) {
      mapMarkers.forEach((marker) => {
        markers.push(
          <Marker
            key={marker.id}
            longitude={marker.lng}
            latitude={marker.lat}
            offset={markerOffset}
            onClick={() => dispatch(setCurrMapMarkerPopup(marker))}
          >
            <LocationSVG size={markerSize} color={blue[600]} />
          </Marker>
        );
      });
    }

    return markers;
  }, [mapMarkers]);

  return (
    <>
      {measureMarkers}
      {markersRender}
    </>
  );
};

export default MarkerLayer;
